import { Search } from '@mui/icons-material';
import styled from '@emotion/styled';
import { uiTheme as t } from './theme';

interface SearchBoxProps {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
}

// `label` y no `div`: así el clic en el icono, en el relleno o en cualquier
// punto de la caja enfoca el campo. Con un div solo respondían los pocos
// píxeles del `input`, y los bordes quedaban muertos.
const Box = styled.label({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  height: 44,
  width: 340,
  maxWidth: '100%',
  padding: '0 14px',
  background: t.color.surface,
  border: `1px solid ${t.color.searchBorder}`,
  borderRadius: 11,
  cursor: 'text',
  transition: 'border-color 0.15s ease',
  '&:focus-within': { borderColor: t.color.primary },
  '& .MuiSvgIcon-root': { fontSize: 20, color: '#aab0b6' },
});

const Field = styled.input({
  flex: 1,
  alignSelf: 'stretch',
  border: 'none',
  outline: 'none',
  background: 'transparent',
  fontFamily: t.font,
  fontSize: 14,
  color: t.color.title,
  '&::placeholder': { color: '#aab0b6' },
});

/**
 * Molécula: campo de búsqueda con icono. Emite el texto ya extraído.
 */
const SearchBox = ({ value, placeholder, onChange }: SearchBoxProps) => (
  <Box>
    <Search />
    <Field value={value} placeholder={placeholder} onChange={e => onChange(e.target.value)} />
  </Box>
);

export default SearchBox;
